module.exports = __webpack_public_path__ + "img/8.bc1d25d6.png";